import { useRouterActions } from 'react-resource-router';

import { SettingsIframe } from 'src/sections/workspace/sections/settings/containers/settings-iframe';

export const IframeWrapped = () => {
  const { push } = useRouterActions();

  return <SettingsIframe push={push} />;
};

// eslint-disable-next-line import/no-default-export
export default IframeWrapped;

export function genPropagateMouseMoveEvent(iframe: HTMLIFrameElement) {
  return function (event: MouseEvent) {
    if (!isSameOrigin(iframe)) {
      return;
    }

    const boundingClientRect = iframe.getBoundingClientRect();
    const mouseEvent = new MouseEvent('mousemove', {
      bubbles: true,
      cancelable: false,
      clientX: event.clientX + boundingClientRect.left,
      clientY: event.clientY + boundingClientRect.top,
    });

    iframe.dispatchEvent(mouseEvent);
  };
}

export function genPropagateMouseUpEvent(iframe: HTMLIFrameElement) {
  return function (_event: MouseEvent) {
    if (!isSameOrigin(iframe)) {
      return;
    }
    const mouseEvent = new MouseEvent('mouseup', {
      bubbles: true,
      cancelable: false,
    });
    iframe.dispatchEvent(mouseEvent);
  };
}

function isSameOrigin(iframe: HTMLIFrameElement) {
  return iframe.contentWindow?.location.origin === window.location.origin;
}
